import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MainService } from '../../service/main.service';
import { ApiUrls } from '../../apiRouts';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-donor-details',
  templateUrl: './donor-details.component.html',
  styleUrl: './donor-details.component.scss'
})
export class DonorDetailsComponent implements OnInit{
  baseUrl = environment.imageURL;
  donorListData: any = [];
  user_type_id: any;

  constructor(
    private route: ActivatedRoute,
    private mainService: MainService,
  ) {
    this.route.params.subscribe((params: any) => {
      this.user_type_id = params['id'] || '0';
    });
  }

  ngOnInit() {
    this.getDonorList();
  }

  getDonorList() {
    this.mainService.getApi(ApiUrls.selectByTypeId + this.user_type_id).subscribe((res: any) => {
      if (res.status == 1) {
        this.donorListData = res.user;
      }
    });
  }
}
